import React from 'react';

function App() {
  return (
    <div id="root"></div>
  );
}

export default App;
